/* eslint-disable react/no-unknown-property */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import longhorizontal from '../../assets/longhorizontal.svg';
import longvertical from "../../assets/longvertical.svg"
import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

import { getPercentUsage } from '../../Utils'
import "./style.css";

function PalletUsage({ containerType, palletid }) {
  const [percent, setPercent] = useState('');

  useEffect(() => {
    async function fetchUsage() {
      const usage = await getPercentUsage(containerType, palletid);
      setPercent(usage ?? 'N/A');
    }
    fetchUsage();
  }, [containerType, palletid]); // Added dependencies safely

  return <div><p>{percent}</p></div>;
}

export const PalletTable = (props) => {
  const { storageContainerType, palletid, containerType, isImperial, rows: dataRows } = props;

  // Calculate total weight directly on render
  let numericWeight = storageContainerType === 3 ? Number(props.totalWeight) + 0 : Number(props.totalWeight) + 12;
  const totalWeightStr = isImperial && storageContainerType !== 4 ? `${numericWeight}lb` : `${numericWeight}kg`;

  // structure the data strictly based on active dataRows prop
  const sortedData = dataRows ? [...dataRows].sort((a, b) => (a.position_no || 0) - (b.position_no || 0)) : [];
  
  const displayRows = [
    {
      quadrant: 'All Items',
      quadData1: sortedData,
    }
  ];

  function Row({ row }) {
    const [open, setOpen] = useState(false);
  
    function rotationImage(width, length) {
      const numericWidth = parseFloat(width);
      const numericLength = parseFloat(length);
      return numericWidth >= numericLength 
        ? <img src={longhorizontal} className="checkmark" alt="horizontal" width="20px" height="20px"/>
        : <img src={longvertical} className="checkmark" alt="vertical" width="20px" height="20px"/>;
    }
  
    return (
      <React.Fragment>  
        <TableRow sx={{ '& > *': { borderBottom: 'unset', backgroundColor: "#F5F5F5" } }}>
          <TableCell component="th" scope="row" align='left' padding='6px 24px'>
            <div style={{ display: "flex", gap: "550px", alignItems: "center"}}>
              {row.quadrant}
              <IconButton size="small" aria-label="expand row" onClick={() => setOpen(!open)}>
                {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </IconButton>
            </div>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box overflow="auto" sx={{ margin: 1 }}>
                <Table size="small" aria-label="items">
                  <TableHead>
                    <TableRow>
                      <TableCell>NSN</TableCell>
                      <TableCell>NIIN</TableCell>
                      <TableCell>Nomenclature</TableCell>
                      <TableCell align="center">Position<br />Order</TableCell>
                      <TableCell align="center">Longest Side<br />Direction</TableCell>
                      <TableCell align="center">Vertical<br />Level</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {row.quadData1.map((quadDataRow, index) => (
                      <TableRow key={quadDataRow.id || index}>
                        <TableCell component="th" scope="row">{quadDataRow.nsn}</TableCell>
                        <TableCell>{quadDataRow.niin}</TableCell>
                        <TableCell>{quadDataRow.nomenclature}</TableCell>
                        <TableCell align="center">{quadDataRow.position_no}</TableCell>
                        <TableCell align="center">{rotationImage(quadDataRow.width, quadDataRow.length)}</TableCell>
                        <TableCell align="center">{quadDataRow.level}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  if (!dataRows) return <div>Loading...</div>;

  return (
    <TableContainer sx={{ maxHeight: 400, overflow: "auto", position: "sticky", width: 675, display: 'flex' }} component={Paper}>
      <Table stickyHeader aria-label="collapsible table" className="palletTable">
        <TableBody>
          {displayRows.map((row) => (
            <Row key={row.quadrant} row={row} />
          ))}
          <TableRow>
            <TableCell component="th" scope="row" align="left" width='1370' padding="3px 24px">
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <span style={{ lineHeight: "0.35" }}>
                  <p>Pallet Total Weight:</p>
                  <p>Percentage Vol Used:</p>
                </span>
                <span style={{ lineHeight: "0.35", textAlign: "right" }}>
                  <p>{totalWeightStr}</p>
                  <PalletUsage containerType={containerType} palletid={palletid} />
                </span>
              </div>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default PalletTable;